import React from 'react';
import { MessageSquare, Calendar } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import Header from '../components/Header';
import Footer from '../components/Footer';

export const BatePapoPage = () => {
  const batePapos = [
    {
      id: 1,
      titulo: 'Bate-papo sobre Ética Profissional',
      data: '2025-01-06',
      participantes: 'Prof. Durval e convidados',
      descricao: 'Discussão informal sobre os desafios éticos na advocacia moderna.'
    },
    {
      id: 2,
      titulo: 'Carreira Jurídica: Dicas e Experiências',
      data: '2024-12-30',
      participantes: 'Prof. Durval',
      descricao: 'Compartilhando experiências e orientações para jovens profissionais.'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0F172A] to-[#1e293b] text-white py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4">
              Bate papo do Direito
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Conversas descontraídas sobre temas relevantes do mundo jurídico
            </p>
          </div>
        </section>

        {/* Bate-papo List */}
        <section className="py-16 md:py-20">
          <div className="max-w-5xl mx-auto px-6">
            <div className="space-y-6">
              {batePapos.map((batepapo) => (
                <Card key={batepapo.id} className="overflow-hidden hover:shadow-xl transition-shadow duration-300 border-0">
                  <CardContent className="p-6 bg-white">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-12 h-12 bg-[#B49163] rounded-full flex items-center justify-center">
                        <MessageSquare size={24} className="text-white" />
                      </div>
                      <div className="flex-grow">
                        <h3 className="text-xl font-serif font-semibold text-[#0F172A] mb-2">
                          {batepapo.titulo}
                        </h3>
                        <p className="text-sm text-[#B49163] mb-2">
                          Com: {batepapo.participantes}
                        </p>
                        <p className="text-gray-600 mb-3">
                          {batepapo.descricao}
                        </p>
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                          <Calendar size={16} />
                          <span>{new Date(batepapo.data).toLocaleDateString('pt-BR')}</span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default BatePapoPage;